import router from '../../router';
import moment from '../../plugins/moment';
import * as MUTATION_TYPES from "./mutation-types";
import * as GETTER_TYPES from "./getter-types";
import * as ACTION_TYPES from "./action-types"

export const searchState = {
  search: {
    type: 1, // Cuando | Donde | Many days
    origin: null,
    destiny: null,
    date: null,
    travellers: {
      adults: 1,
      childs: 0,
      babies: 0
    },
    isGift: false,
    dateRange:{
      start: null,
      end: null
    }
  }
};

export const searchGetters = {
  [GETTER_TYPES.GET_SEARCH](state) {
    return state.search;
  }
}

export const searchMutations = {
  [MUTATION_TYPES.SEARCH_UPDATE](state, payload) {
    state.search = {...payload}
  },
  [MUTATION_TYPES.SEARCH_UPDATE](state, payload) {
    state.search = {...payload}
  },
  [MUTATION_TYPES.SET_SEARCH_ORIGIN](state, payload) {
    state.search.origin = payload;
  },
  [MUTATION_TYPES.SET_SEARCH_DESTINY](state, payload) {
    state.search.destiny = payload;
  },
  [MUTATION_TYPES.SET_SEARCH_DATE](state, payload) {
    state.search.date = payload;
  },
  [MUTATION_TYPES.SET_SEARCH_MORE_START_DATE](state, payload) {
    state.search.dateRange.start = payload;
  },
  [MUTATION_TYPES.SET_SEARCH_MORE_END_DATE](state, payload) {
    state.search.dateRange.end = payload;
  },
  [MUTATION_TYPES.SET_TRAVELLERS](state, payload) {
    state.search.travellers = payload;
  }
};

export const searchActions = {
  [ACTION_TYPES.SEARCH_WHEN]({ commit, state }, payload) {
    if (state.search.origin && state.search.travellers.adults > 0 && state.search.date && state.search.date.isValid()) {
      const route = {
        name: "destinies-results",
        params: {
          origin: state.search.origin.code
        },
        query: {
          fecha: moment(state.search.date, "YYYY-MM-DD").format(
            "DD-MM-YYYY"
          ),
          adults: state.search.travellers.adults,
          childs: state.search.travellers.childs,
          babies: state.search.travellers.babies
        }
      }
      router.push(route);
    } else {
      throw Error;
    }
  },
  [ACTION_TYPES.SEARCH_MORE_DAYS]({ commit, state }, payload) {
    if (state.search.origin && state.search.travellers.adults > 0 && state.search.dateRange ) {
      const route = {
        name: "nights-destinations",
        params: {
          origin: state.search.origin.code
        },
        query: {
          start: state.search.dateRange.start.format("YYYY-MM-DD"),
          end: state.search.dateRange.end.format("YYYY-MM-DD"),
          adults: state.search.travellers.adults,
          children: state.search.travellers.childs,
          babies: state.search.travellers.babies
        }
      }
      router.push(route).catch(() => {});
    } else {
      throw Error;
    }
  },
  [ACTION_TYPES.SEARCH_WHERE]({ commit, state }, payload) {
    if (state.search.origin && state.search.travellers.adults > 0 && state.search.destiny) {
      const route = {
        name: "calendar",
        params: {
          origin: state.search.origin.code,
          destiny: state.search.destiny.code
        },
        query: {
          adults: state.search.travellers.adults,
          childs: state.search.travellers.childs,
          babies: state.search.travellers.babies
        }
      };
      router.push(route);
    } else {
      throw Error;
    }
  },
  [ACTION_TYPES.SET_SEARCH]({ commit, state }, payload) {
    commit(MUTATION_TYPES.SEARCH_UPDATE, payload);
  },
  [ACTION_TYPES.SET_TRAVELLERS]({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.adults && payload.childs !== null && payload.babies !== null) {
        commit(MUTATION_TYPES.SET_TRAVELLERS, payload);
        resolve()
      } else {
        reject()
      }
    });
  },
  [ACTION_TYPES.SET_SEARCH_DESTINY]({ commit, state }, payload) {
    commit(MUTATION_TYPES.SET_SEARCH_DESTINY, payload);
  }
}


